/** Modulo Colaborador (50) — codigos em contracts/enums.yaml */
export const COLABORADOR_ACAO = {
  CRIAR: 501,
  ATUALIZAR: 502,
  REMOVER: 503,
} as const;

export const COLABORADOR_ACOES_MODULO = [
  COLABORADOR_ACAO.CRIAR,
  COLABORADOR_ACAO.ATUALIZAR,
  COLABORADOR_ACAO.REMOVER,
] as const;
